/* eslint-disable react/prop-types */ // TODO: add props
import { StaticEquation } from 'edrolo/domains/exams';

const EquationSolution = ({ response, equations }) => (
  <ul className="equation-solution">
    {equations.map((equation, i) => (
      <li key={`${response ? response.id : 'response'}-${i}`}>
        <StaticEquation equation={equation} />
      </li>
    ))}
  </ul>
);

export default EquationSolution;
